function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.313726%,15.686275%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 15 7.5 C 15 3.359375 11.640625 0 7.5 0 C 3.359375 0 0 3.359375 0 7.5 C 0 11.640625 3.359375 15 7.5 15 C 11.640625 15 15 11.640625 15 7.5 Z M 15 7.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196079%,90.196079%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 6.796875 11.71875 L 8.203125 11.71875 L 8.203125 10.3125 L 6.796875 10.3125 Z M 6.796875 2.8125 L 6.796875 8.90625 L 8.203125 8.90625 L 8.203125 2.8125 Z M 6.796875 2.8125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.e260b817d7f453d2b40e9f43644a4a04.svg";
export { ForwardRef as ReactComponent };